"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIES = void 0;
exports.COOKIES = {
    GA: '_ga',
    YM_UID: '_ym_uid',
};
